(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb427"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb427"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dYSjd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: !0
}), module.exports.getParam = module.exports.getAllParams = module.exports.default = module.exports.IFRAME_STYLE = void 0;
const $a2db01901090f9a4$var$getSrcUrl = ()=>{
    const a = document.getElementById("chat-widget-1925");
    return a ? a.src : null;
}, $a2db01901090f9a4$var$getParam = (a)=>{
    const b = $a2db01901090f9a4$var$getSrcUrl();
    return b ? new URL(b).searchParams.get(a) : "";
};
module.exports.getParam = $a2db01901090f9a4$var$getParam;
const $a2db01901090f9a4$var$getAllParams = ()=>{
    const a = $a2db01901090f9a4$var$getSrcUrl();
    return a ? [
        ...new URL(a).searchParams.entries()
    ].map((a)=>{
        let [b, c] = a;
        return {
            name: b,
            value: c
        };
    }).filter((a)=>![
            "c",
            "i",
            "s"
        ].includes(a.name)) : [];
};
module.exports.getAllParams = $a2db01901090f9a4$var$getAllParams;
const $a2db01901090f9a4$var$IFRAME_STYLE = module.exports.IFRAME_STYLE = `<style>
      @import url('https://fonts.googleapis.com/css?family=Open+Sans:400,700|Poppins:400,600,700&display=swap');

      * {
        font-family: 'Open Sans', sans-serif;
      }

      h1 {
        font-family: 'Poppins', sans-serif;
        margin-bottom: 0.25rem;
        font-size: 1.75em;
      }
      h2 {
        font-size: 1.25em;
        font-family: 'Poppins', sans-serif;
      }
      h3,
      h4,
      h5,
      h6 {
        font-family: 'Poppins', sans-serif;
      }

      body {
        margin: 0;
        padding-left: 2rem;
      }
      #root {
        height: 100%;
        padding-bottom: 1.5rem;
        padding-right: 1.5rem;
        box-sizing: border-box;
        display:flex;
        justify-content: flex-end;
        align-items:flex-end;
      }
      @media only screen and (max-width: 420px) {
        body, #root {
          padding: 0;
        }
      }
      // 250px is breakpoint for launcher mode
      @media only screen and (min-width: 250px) and (max-width: 420px) {
        #root > div:not(:nth-last-child(2)) {
          width:100vw;
          height:100vh;
          max-height:100vh;
        }
      }
    </style>`, $a2db01901090f9a4$var$generateIframe = function() {
    let a = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : [];
    return `
  <head>
    <meta name="viewport" content="width=device-width,initial-scale=1.0">
    <meta name="client" content="${$a2db01901090f9a4$var$getParam("c")}">
    <meta name="identifier" content="${$a2db01901090f9a4$var$getParam("i")}">
    <meta name="setting" content="${$a2db01901090f9a4$var$getParam("s")}">
    <meta name="variables" content='${JSON.stringify($a2db01901090f9a4$var$getAllParams())}'>
    ${window.location && `<meta name="browser_url" content=${window.location.href}>`}
    <base target="_blank">
    ${$a2db01901090f9a4$var$IFRAME_STYLE}
  </head>
  <body>
    <div id="root"></div>
    ${a.map((a)=>`<script src="${a}"></script>`).join(" ")}
  </body>
`;
};
var $a2db01901090f9a4$var$_default = module.exports.default = $a2db01901090f9a4$var$generateIframe;

});

var $7dcf7a3b7cf59f60$exports = {};
(function(global1) {
    /**
   * Polyfill URLSearchParams
   *
   * Inspired from : https://github.com/WebReflection/url-search-params/blob/master/src/url-search-params.js
   */ var checkIfIteratorIsSupported = function() {
        try {
            return !!Symbol.iterator;
        } catch (error) {
            return false;
        }
    };
    var iteratorSupported = checkIfIteratorIsSupported();
    var createIterator = function(items) {
        var iterator = {
            next: function() {
                var value = items.shift();
                return {
                    done: value === void 0,
                    value: value
                };
            }
        };
        if (iteratorSupported) iterator[Symbol.iterator] = function() {
            return iterator;
        };
        return iterator;
    };
    /**
   * Search param name and values should be encoded according to https://url.spec.whatwg.org/#urlencoded-serializing
   * encodeURIComponent() produces the same result except encoding spaces as `%20` instead of `+`.
   */ var serializeParam = function(value) {
        return encodeURIComponent(value).replace(/%20/g, '+');
    };
    var deserializeParam = function(value) {
        return decodeURIComponent(String(value).replace(/\+/g, ' '));
    };
    var polyfillURLSearchParams = function() {
        var URLSearchParams = function(searchString) {
            Object.defineProperty(this, '_entries', {
                writable: true,
                value: {}
            });
            var typeofSearchString = typeof searchString;
            if (typeofSearchString === 'undefined') ;
            else if (typeofSearchString === 'string') {
                if (searchString !== '') this._fromString(searchString);
            } else if (searchString instanceof URLSearchParams) {
                var _this = this;
                searchString.forEach(function(value, name) {
                    _this.append(name, value);
                });
            } else if (searchString !== null && typeofSearchString === 'object') {
                if (Object.prototype.toString.call(searchString) === '[object Array]') for(var i = 0; i < searchString.length; i++){
                    var entry = searchString[i];
                    if (Object.prototype.toString.call(entry) === '[object Array]' || entry.length !== 2) this.append(entry[0], entry[1]);
                    else throw new TypeError('Expected [string, any] as entry at index ' + i + ' of URLSearchParams\'s input');
                }
                else {
                    for(var key in searchString)if (searchString.hasOwnProperty(key)) this.append(key, searchString[key]);
                }
            } else throw new TypeError('Unsupported input\'s type for URLSearchParams');
        };
        var proto = URLSearchParams.prototype;
        proto.append = function(name, value) {
            if (name in this._entries) this._entries[name].push(String(value));
            else this._entries[name] = [
                String(value)
            ];
        };
        proto.delete = function(name) {
            delete this._entries[name];
        };
        proto.get = function(name) {
            return name in this._entries ? this._entries[name][0] : null;
        };
        proto.getAll = function(name) {
            return name in this._entries ? this._entries[name].slice(0) : [];
        };
        proto.has = function(name) {
            return name in this._entries;
        };
        proto.set = function(name, value) {
            this._entries[name] = [
                String(value)
            ];
        };
        proto.forEach = function(callback, thisArg) {
            var entries;
            for(var name in this._entries)if (this._entries.hasOwnProperty(name)) {
                entries = this._entries[name];
                for(var i = 0; i < entries.length; i++)callback.call(thisArg, entries[i], name, this);
            }
        };
        proto.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return createIterator(items);
        };
        proto.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return createIterator(items);
        };
        proto.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return createIterator(items);
        };
        if (iteratorSupported) proto[Symbol.iterator] = proto.entries;
        proto.toString = function() {
            var searchArray = [];
            this.forEach(function(value, name) {
                searchArray.push(serializeParam(name) + '=' + serializeParam(value));
            });
            return searchArray.join('&');
        };
        Object.defineProperty(proto, 'size', {
            get: function() {
                return this._entries ? Object.keys(this._entries).length : 0;
            }
        });
        global1.URLSearchParams = URLSearchParams;
    };
    var checkIfURLSearchParamsSupported = function() {
        try {
            var URLSearchParams = global1.URLSearchParams;
            return new URLSearchParams('?a=1').toString() === 'a=1' && typeof URLSearchParams.prototype.set === 'function' && typeof URLSearchParams.prototype.entries === 'function';
        } catch (e) {
            return false;
        }
    };
    if (!checkIfURLSearchParamsSupported()) polyfillURLSearchParams();
    var proto = global1.URLSearchParams.prototype;
    if (typeof proto.sort !== 'function') proto.sort = function() {
        var _this = this;
        var items = [];
        this.forEach(function(value, name) {
            items.push([
                name,
                value
            ]);
            if (!_this._entries) _this.delete(name);
        });
        items.sort(function(a, b) {
            if (a[0] < b[0]) return -1;
            else if (a[0] > b[0]) return 1;
            else return 0;
        });
        if (_this._entries) _this._entries = {};
        for(var i = 0; i < items.length; i++)this.append(items[i][0], items[i][1]);
    };
    if (typeof proto._fromString !== 'function') Object.defineProperty(proto, '_fromString', {
        enumerable: false,
        configurable: false,
        writable: false,
        value: function(searchString) {
            if (this._entries) this._entries = {};
            else {
                var keys = [];
                this.forEach(function(value, name) {
                    keys.push(name);
                });
                for(var i = 0; i < keys.length; i++)this.delete(keys[i]);
            }
            searchString = searchString.replace(/^\?/, '');
            var attributes = searchString.split('&');
            var attribute;
            for(var i = 0; i < attributes.length; i++){
                attribute = attributes[i].split('=');
                this.append(deserializeParam(attribute[0]), attribute.length > 1 ? deserializeParam(attribute.slice(1).join('=')) : '');
            }
        }
    });
// HTMLAnchorElement
})(typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : $7dcf7a3b7cf59f60$exports);
(function(global1) {
    /**
   * Polyfill URL
   *
   * Inspired from : https://github.com/arv/DOM-URL-Polyfill/blob/master/src/url.js
   */ var checkIfURLIsSupported = function() {
        try {
            var u = new global1.URL('b', 'http://a');
            u.pathname = 'c d';
            return u.href === 'http://a/c%20d' && u.searchParams;
        } catch (e) {
            return false;
        }
    };
    var polyfillURL = function() {
        var _URL = global1.URL;
        var URL = function(url, base) {
            if (typeof url !== 'string') url = String(url);
            if (base && typeof base !== 'string') base = String(base);
            // Only create another document if the base is different from current location.
            var doc = document, baseElement;
            if (base && (global1.location === void 0 || base !== global1.location.href)) {
                base = base.toLowerCase();
                doc = document.implementation.createHTMLDocument('');
                baseElement = doc.createElement('base');
                baseElement.href = base;
                doc.head.appendChild(baseElement);
                try {
                    if (baseElement.href.indexOf(base) !== 0) throw new Error(baseElement.href);
                } catch (err) {
                    throw new Error('URL unable to set base ' + base + ' due to ' + err);
                }
            }
            var anchorElement = doc.createElement('a');
            anchorElement.href = url;
            if (baseElement) {
                doc.body.appendChild(anchorElement);
                anchorElement.href = anchorElement.href; // force href to refresh
            }
            var inputElement = doc.createElement('input');
            inputElement.type = 'url';
            inputElement.value = url;
            if (anchorElement.protocol === ':' || !/:/.test(anchorElement.href) || !inputElement.checkValidity() && !base) throw new TypeError('Invalid URL');
            Object.defineProperty(this, '_anchorElement', {
                value: anchorElement
            });
            // create a linked searchParams which reflect its changes on URL
            var searchParams = new global1.URLSearchParams(this.search);
            var enableSearchUpdate = true;
            var enableSearchParamsUpdate = true;
            var _this = this;
            [
                'append',
                'delete',
                'set'
            ].forEach(function(methodName) {
                var method = searchParams[methodName];
                searchParams[methodName] = function() {
                    method.apply(searchParams, arguments);
                    if (enableSearchUpdate) {
                        enableSearchParamsUpdate = false;
                        _this.search = searchParams.toString();
                        enableSearchParamsUpdate = true;
                    }
                };
            });
            Object.defineProperty(this, 'searchParams', {
                value: searchParams,
                enumerable: true
            });
            var search = void 0;
            Object.defineProperty(this, '_updateSearchParams', {
                enumerable: false,
                configurable: false,
                writable: false,
                value: function() {
                    if (this.search !== search) {
                        search = this.search;
                        if (enableSearchParamsUpdate) {
                            enableSearchUpdate = false;
                            this.searchParams._fromString(this.search);
                            enableSearchUpdate = true;
                        }
                    }
                }
            });
        };
        var proto = URL.prototype;
        var linkURLWithAnchorAttribute = function(attributeName) {
            Object.defineProperty(proto, attributeName, {
                get: function() {
                    return this._anchorElement[attributeName];
                },
                set: function(value) {
                    this._anchorElement[attributeName] = value;
                },
                enumerable: true
            });
        };
        [
            'hash',
            'host',
            'hostname',
            'port',
            'protocol'
        ].forEach(function(attributeName) {
            linkURLWithAnchorAttribute(attributeName);
        });
        Object.defineProperty(proto, 'search', {
            get: function() {
                return this._anchorElement['search'];
            },
            set: function(value) {
                this._anchorElement['search'] = value;
                this._updateSearchParams();
            },
            enumerable: true
        });
        Object.defineProperties(proto, {
            'toString': {
                get: function() {
                    var _this = this;
                    return function() {
                        return _this.href;
                    };
                }
            },
            'href': {
                get: function() {
                    return this._anchorElement.href.replace(/\?$/, '');
                },
                set: function(value) {
                    this._anchorElement.href = value;
                    this._updateSearchParams();
                },
                enumerable: true
            },
            'pathname': {
                get: function() {
                    return this._anchorElement.pathname.replace(/(^\/?)/, '/');
                },
                set: function(value) {
                    this._anchorElement.pathname = value;
                },
                enumerable: true
            },
            'origin': {
                get: function() {
                    // get expected port from protocol
                    var expectedPort = {
                        'http:': 80,
                        'https:': 443,
                        'ftp:': 21
                    }[this._anchorElement.protocol];
                    // add port to origin if, expected port is different than actual port
                    // and it is not empty f.e http://foo:8080
                    // 8080 != 80 && 8080 != ''
                    var addPortToOrigin = this._anchorElement.port != expectedPort && this._anchorElement.port !== '';
                    return this._anchorElement.protocol + '//' + this._anchorElement.hostname + (addPortToOrigin ? ':' + this._anchorElement.port : '');
                },
                enumerable: true
            },
            'password': {
                get: function() {
                    return '';
                },
                set: function(value) {},
                enumerable: true
            },
            'username': {
                get: function() {
                    return '';
                },
                set: function(value) {},
                enumerable: true
            }
        });
        URL.createObjectURL = function(blob) {
            return _URL.createObjectURL.apply(_URL, arguments);
        };
        URL.revokeObjectURL = function(url) {
            return _URL.revokeObjectURL.apply(_URL, arguments);
        };
        global1.URL = URL;
    };
    if (!checkIfURLIsSupported()) polyfillURL();
    if (global1.location !== void 0 && !('origin' in global1.location)) {
        var getOrigin = function() {
            return global1.location.protocol + '//' + global1.location.hostname + (global1.location.port ? ':' + global1.location.port : '');
        };
        try {
            Object.defineProperty(global1.location, 'origin', {
                get: getOrigin,
                enumerable: true
            });
        } catch (e) {
            setInterval(function() {
                global1.location.origin = getOrigin();
            }, 100);
        }
    }
})(typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : $7dcf7a3b7cf59f60$exports);


var $764a41f5f660cd4f$exports = {};
"use strict";

var $764a41f5f660cd4f$var$_iframe = $764a41f5f660cd4f$var$_interopRequireWildcard((parcelRequire("dYSjd")));
Object.defineProperty($764a41f5f660cd4f$exports, "__esModule", {
    value: !0
}), Object.defineProperty($764a41f5f660cd4f$exports, "IFRAME_STYLE", {
    enumerable: !0,
    get: function() {
        return $764a41f5f660cd4f$var$_iframe.IFRAME_STYLE;
    }
}), $764a41f5f660cd4f$exports.default = void 0, Object.defineProperty($764a41f5f660cd4f$exports, "generateIframe", {
    enumerable: !0,
    get: function() {
        return $764a41f5f660cd4f$var$_iframe.default;
    }
}), Object.defineProperty($764a41f5f660cd4f$exports, "getAllParams", {
    enumerable: !0,
    get: function() {
        return $764a41f5f660cd4f$var$_iframe.getAllParams;
    }
}), Object.defineProperty($764a41f5f660cd4f$exports, "getParam", {
    enumerable: !0,
    get: function() {
        return $764a41f5f660cd4f$var$_iframe.getParam;
    }
});
function $764a41f5f660cd4f$var$_interopRequireWildcard(a, b) {
    if ("function" == typeof WeakMap) var c = new WeakMap, d = new WeakMap;
    return ($764a41f5f660cd4f$var$_interopRequireWildcard = function(a, b) {
        if (!b && a && a.__esModule) return a;
        var e, g, h = {
            __proto__: null,
            default: a
        };
        if (null === a || "object" != typeof a && "function" != typeof a) return h;
        if (e = b ? d : c) {
            if (e.has(a)) return e.get(a);
            e.set(a, h);
        }
        for(const c in a)"default" != c && ({}).hasOwnProperty.call(a, c) && ((g = (e = Object.defineProperty) && Object.getOwnPropertyDescriptor(a, c)) && (g.get || g.set) ? e(h, c, g) : h[c] = a[c]);
        return h;
    })(a, b);
}
const $764a41f5f660cd4f$var$inject = function(a, b) {
    let c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : ()=>{};
    if (Array.isArray(a) || (a = [
        a
    ]), b) {
        const a = document.createElement("link");
        a.type = "text/css", a.rel = "stylesheet", a.href = b, document.head.appendChild(a);
    }
    const d = document.createElement("iframe"), e = (0, $764a41f5f660cd4f$var$_iframe.default)(a);
    d.id = "chat-widget-iframe", d.title = "Chat Widget", d.setAttribute("scrolling", "no"), d.setAttribute("frameBorder", 0), d.classList.add("chat-widget-iframe-launcher-mode"), d.classList.add("chat-widget-iframe-hidden"), d.onload = c, document.body.appendChild(d), d.contentWindow.document.open(), d.contentWindow.document.write(e), d.contentWindow.document.close(), d.contentWindow.document.getElementsByTagName("HTML")[0]?.setAttribute("lang", "en");
    const f = (a)=>{
        const { height: b } = a.data.payload.cta, c = b + .2 * b;
        100 > c || (d.style.height = c + "px");
    }, g = (a)=>{
        const { height: b, width: c } = a.data.payload.size;
        d.classList.contains("chat-widget-iframe-launcher-mode") || d.setAttribute("Style", `width : calc(${c} + 60px);
        height : calc(${b} + 60px);`);
    }, h = function() {
        let a = !!(0 < arguments.length && void 0 !== arguments[0]) && arguments[0];
        a && (d.style.width = "90px", d.style.height = "90px"), d.removeAttribute("Style");
    };
    window.addEventListener("message", (a)=>a.data ? "widget shown" === a.data ? (d.classList.remove("chat-widget-iframe-hidden"), d.classList.add("chat-widget-iframe-shown")) : "widget opened" === a.data ? (d.classList.remove("chat-widget-iframe-launcher-mode"), d.classList.add("chat-widget-iframe-message-mode")) : "widget closed" === a.data ? (d.classList.remove("chat-widget-iframe-message-mode"), h(!0), d.classList.add("chat-widget-iframe-launcher-mode")) : "cta shown" === a.data ? d.classList.add("chat-widget-iframe-with-cta") : "cta closed" === a.data ? (h(), d.classList.remove("chat-widget-iframe-with-cta")) : "iframe modal opened" === a.data ? (h(), d.classList.remove("chat-widget-iframe-message-mode"), d.classList.add("chat-widget-iframe-modal-mode")) : "iframe modal closed" === a.data ? (d.classList.add("chat-widget-iframe-message-mode"), d.classList.remove("chat-widget-iframe-modal-mode")) : void ("css-engine" === a.data?.type && (a.data.payload?.cta && f(a), a.data.payload?.size && g(a))) : void 0);
};
var $764a41f5f660cd4f$var$_default = $764a41f5f660cd4f$exports.default = $764a41f5f660cd4f$var$inject;





(0, (/*@__PURE__*/$parcel$interopDefault($764a41f5f660cd4f$exports)))("https://widget.sopranodesign.ai/static/js/main.js", "https://widget.sopranodesign.ai/widget/widget.css");

})();
//# sourceMappingURL=widget.js.map
